import React from "react";
import { Button, Tabs } from "antd";
import { UnsubscribedPlanDetails } from "./UnsubscribedPlanDetails";
import { UnsubscribedPaymentButton } from "./UnsubscribedPaymentButton";
import languageFile from "../../../../public/languages/Translation";
import { urlName } from "../../../config/index";
import styles from "./style.module.scss";

const TabPane = Tabs.TabPane;
export const UnsubscribedPaymentPlan = ({ openPaymentPortal }) => {
	return (
		<div className={styles.outerPage}>
			{/* <div className='payment-plans'> */}
			{/* <Tabs defaultActiveKey='1' animated={false}>
					<TabPane tab={<span>{languageFile[localStorage.getItem('language')]["24111"]}</span>} key='1'>
						{ urlName=="app.localclarity.com" &&
							<UnsubscribedPlanDetails /> }
						<UnsubscribedPaymentButton
							openPaymentPortal={openPaymentPortal}
						/>
					</TabPane>
				</Tabs> */}
			<div className={styles.paymentBlock}>
				<div className={styles.heading}>
					<h2>Disruptive by Design.</h2>
					<h2>Transparent by Choice.</h2>
				</div>
				<div className={styles.description}>
					Explore the custom Workspace pricing established for your account,
					tailored to deliver maximum value based on your needs and scale.
				</div>
				<div className={styles.buttonblock}>
					<Button
						type="primary"
						onClick={openPaymentPortal}>
						Access Pricing
					</Button>
				</div>
			</div>
		</div>
	);
};
